import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";
import { useCustomMutation, useInvalidate } from "@refinedev/core";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTranslation } from "../../hooks/useTranslation";

interface DeleteDialogProps {
  handleClose: () => void;
  dialogType: "selected" | "all" | undefined;
  values: object;
  resetSelection: () => void;
  endpoint: string;
}

export const DeleteDialog = (props: DeleteDialogProps) => {
  const { handleClose, resetSelection, dialogType, endpoint, values } = props;

  const { translate, translateWithoutPrefix } = useTranslation(
    dialogType === "selected"
      ? "common.components.deleteList.deleteDialog"
      : "common.components.deleteList.deleteAllDialog",
  );

  const invalidate = useInvalidate();
  const { mutate, isLoading } = useCustomMutation();

  const handleDelete = () => {
    mutate(
      {
        url: endpoint + (dialogType === "selected" ? "" : "/all"),
        method: "delete",
        values: dialogType === "selected" ? values : {},
        successNotification: () => {
          return {
            message: translate("success"),
            type: "success",
          };
        },
      },
      {
        onSuccess: () => {
          invalidate({
            resource: "all",
            invalidates: ["all"],
          });
          resetSelection();
          handleClose();
        },
      },
    );
  };

  return (
    <Dialog
      open={dialogType !== undefined}
      onClose={isLoading ? undefined : handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{translate("title")}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {translate("description")}
        </DialogContentText>
        {dialogType === "all" && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {translateWithoutPrefix(
              "common.components.deleteList.deleteAllDialog.queueWarning",
            )}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          {translateWithoutPrefix("buttons.cancel")}
        </Button>
        <LoadingButton onClick={handleDelete} autoFocus loading={isLoading}>
          {translate("delete")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
